import { Icon } from "../../icons";
import { isApplePlatform } from "../CommandPalette/CommandPalette";
import { isSearchSeedKey, searchShortcutLabel } from "./searchSeed";

const PALETTE_SHORTCUTS = "Meta+F Control+F Meta+K Control+K";

/** The search field in the middle of the bar; it opens the command palette. */
export function TopbarSearch({ onSearch }: { onSearch?: (initialQuery?: string) => void }): React.JSX.Element {
  return (
    <button
      type="button"
      className="nb-top-search"
      onClick={() => onSearch?.()}
      onKeyDown={(e) => {
        // Typing while the field is focused opens the palette with that text.
        if (isSearchSeedKey(e)) {
          e.preventDefault();
          onSearch?.(e.key);
        }
      }}
      aria-label="Search the suite"
      aria-haspopup="dialog"
      aria-keyshortcuts={PALETTE_SHORTCUTS}
    >
      <Icon name="search" />
      <span className="nb-top-search-text">Search the suite</span>
      <kbd className="nb-kbd">{searchShortcutLabel(isApplePlatform())}</kbd>
    </button>
  );
}
